export const API_URL = process.env.NEXT_PUBLIC_API_URL
export const API_TOKEN = process.env.NEXT_PUBLIC_API_TOKEN
export const GMAPS_API_KEY = process.env.NEXT_PUBLIC_GMAPS_API_KEY
export const PAPER_INV_MORE_EXPENSIVE = process.env.NEXT_PUBLIC_PAPER_INVOICE_MORE_EXPENSIVE === 'true'
export const BANK_TRANSFER_MORE_EXPENSIVE = process.env.NEXT_PUBLIC_BANK_TRANSFER_MORE_EXPENSIVE === 'true'
export const CMS_URL = process.env.NEXT_PUBLIC_CMS_URL
